<template>
  <div>
    <!-- SDA Expiration Alert -->
    <v-row v-if="sdaData && sdaData.SDAInv && sdaData.SDAInv.HmeromExpire">
      <v-col cols="12">
        <v-alert :type="sdaExpireAlertType" outlined class="mb-2">
          <template v-if="isSDAExpired">
            Το Συγκεντρωτικό Δελτίο έχει λήξει. Πρέπει να το ανανεώσετε για να συνεχίσετε.
            
            <div class="mt-4 d-flex flex-row">
              <v-btn 
                color="primary" 
                class="mr-2" 
                @click="$emit('refresh-sda')" 
                :disabled="sdaData && sdaData.SDAInv.StandBy > 0"
              >
                ΑΝΑΝΕΩΣΗ
              </v-btn>
              <v-btn 
                color="warning" 
                outlined 
                @click="$emit('close-sda')" 
                :disabled="sdaData && sdaData.SDAInv.StandBy > 0"
              >
                ΚΛΕΙΣΙΜΟ
              </v-btn>
            </div>
          </template>
          <template v-else>
            <template v-if="daysUntilSDAExpire !== null">
              <span v-if="daysUntilSDAExpire < 1">Το Συγκεντρωτικό λήγει σήμερα.</span>
              <span v-else>
                Το Συγκεντρωτικό λήγει σε {{ Math.floor(daysUntilSDAExpire) ? Math.floor(daysUntilSDAExpire)+' μέρες': ' σήμερα' }}.
              </span>
            </template>
          </template>
        </v-alert>
      </v-col>
    </v-row>

    <!-- StandBy Alert -->
    <v-alert 
      v-if="sdaData && sdaData.SDAInv && sdaData.SDAInv.StandBy > 0" 
      type="warning"  
      color="#dfcd0088" 
      class="mt-2"
    >
      Υπάρχουν ({{ sdaData.SDAInv.StandBy }}) ΔΑ σε αναμονή, που δεν έχουν εκδοθεί. Παρακαλώ επικοινωνήστε με το γραφείο σας.
    </v-alert>

    <!-- Client Warning Alert -->
    <v-alert 
      class="mt-2" 
      v-if="sdaData && sdaData.client && sdaData.client.PosibleRejectReason" 
      type="warning" 
      color="#dfcd0088"
    >
      Προειδοποίηση: {{ sdaData.client.PosibleRejectReason }}
      Ενδεχομένως να μην ειναι δυνατή η αποστολή του Συγκεντρωτικού Δελτίου. Παρακαλώ επικοινωνήστε με το γραφείο, πριν συνεχίσετε.
    </v-alert>

    <!-- Error Alert -->
    <v-alert v-if="error" type="error" outlined>
      {{ error }}
    </v-alert>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'SDAAlerts',
  props: {
    sdaData: {
      type: Object,
      default: null
    },
    error: {
      type: String,
      default: null
    }
  },
  computed: {
    isSDAExpired() {
      if (!this.sdaData?.SDAInv?.HmeromExpire) return false;
      return moment().isAfter(moment(this.sdaData.SDAInv.HmeromExpire));
    },
    daysUntilSDAExpire() {
      if (!this.sdaData?.SDAInv?.HmeromExpire) return null;
      const now = moment();
      const expire = moment(this.sdaData.SDAInv.HmeromExpire);
      return expire.diff(now, 'days', true); // fractional days
    },
    sdaExpireAlertType() {
      if (this.isSDAExpired) return 'error';
      if (this.daysUntilSDAExpire !== null && this.daysUntilSDAExpire < 1 && this.daysUntilSDAExpire >= 0) return 'warning';
      return 'info';
    }
  }
}
</script> 